var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wireframe/40") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Landing-page",
    transform: "translate(-1129.000000, -797.000000)",
    fill: "#00095B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wireframe/40",
    transform: "translate(1129.000000, 797.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.000945,0 L10.3647704,9.54629752 L0,11.0771625 L7.36155736,18.2301629 L5.62464562,29 L15.000945,24.0443767 L24.3772444,29 L22.6403326,18.2301629 L30,11.0771625 L19.6352296,9.54629752 L15.000945,0 Z M9.37629938,17.5655716 L4.02948403,12.408266 L11.6102816,11.2884488 L15.000945,4.3063982 L18.3916084,11.2884488 L25.972406,12.408266 L20.6255906,17.5655716 L21.8843319,25.5156974 L15.000945,21.8930984 L8.11755812,25.5156974 L9.37629938,17.5655716 Z",
    id: "Favorites"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.dc27431b1a7f21a502da7c052bec55c2.svg";
export { ForwardRef as ReactComponent };